function getSessionIdFromCookieOrStorage() {
  const cookieMatch = /(?:^|; )session_id=([^;]*)/.exec(document.cookie);
  const cookieSessionId = cookieMatch?.[1] ? decodeURIComponent(cookieMatch[1]).trim() : '';

  if (cookieSessionId && cookieSessionId !== 'undefined' && cookieSessionId !== 'null') {
    return cookieSessionId;
  }

  const storageSessionId = localStorage.getItem('session_id');
  if (storageSessionId && storageSessionId !== 'undefined' && storageSessionId !== 'null') {
    return storageSessionId;
  }

  return null;
}

/**
 * @param {unknown} patient
 * @param {unknown} project
 */
export async function generateTemporalToken(patient, project) {
  const API_URL_ENV = process.env.API_URL;
  const API_URL = `${API_URL_ENV}/tokens/generate-temporal-token`;

  console.log('Fetching token validation from API:', API_URL);

  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');

  const body = JSON.stringify({
    patient_id: patient,
    project_id: project,
    viewer: '3D Viewer',
  });

  const session_id = getSessionIdFromCookieOrStorage();
  if (session_id) {
    myHeaders.append('x-api-key', session_id);
  }

  try {
    const response = await fetch(API_URL, {
      method: 'POST',
      headers: myHeaders,
      body: body,
      credentials: 'include',
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || 'Error generating temporal token');
    }

    const data = await response.json();

    return data.ticket;
  } catch (error) {
    console.error('Error generating temporal token:', error);
  }
}
